import { withObjectionFaqs } from "@/lib/faqs";
import { createFileRoute } from "@tanstack/react-router";
import { ServicePageLayout } from "@/components/ServicePageLayout";
import { SERVICE_PAGES } from "@/lib/service-content";
import { buildService, buildFaqPage, buildBreadcrumbs, buildLocalBusiness } from "@/components/SchemaJsonLd";

const data = SERVICE_PAGES["solid-color-epoxy-flooring"];

export const Route = createFileRoute("/services/solid-color-epoxy-flooring")({
  head: () => ({
    meta: [
      { title: "Solid Color Epoxy Flooring in the Calgary region | MLC Epoxy Floors" },
      { name: "description", content: "Clean, uniform solid color epoxy floor coatings for garages, commercial spaces, and warehouses. Serving Calgary AB and the entire Calgary Region." },
      { property: "og:title", content: "Solid Color Epoxy Flooring | MLC Epoxy Floors" },
      { property: "og:description", content: "Sleek single-color epoxy floors with polyaspartic topcoat — gloss or satin in any color." },
      { property: "og:url", content: "/services/solid-color-epoxy-flooring" },
    ],
    links: [{ rel: "canonical", href: "/services/solid-color-epoxy-flooring" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(buildLocalBusiness()) },
      { type: "application/ld+json", children: JSON.stringify(buildService(data.name, data.slug, data.intro)) },
      { type: "application/ld+json", children: JSON.stringify(buildFaqPage(withObjectionFaqs(data.faqs))) },
      { type: "application/ld+json", children: JSON.stringify(buildBreadcrumbs([
        { name: "Home", href: "/" }, { name: "Services", href: "/services" }, { name: data.name, href: `/services/${data.slug}` }
      ])) },
    ],
  }),
  component: () => <ServicePageLayout {...data} />,
});
